module.exports = __webpack_public_path__ + "img/percent.cf1bfdac.svg";